export const BLOCK_FOR_BOOKING_ROOM_TITLE = 'Collaborat-IN‘ Area 1 & 2';

export const MAILS_FOR_BOOKING = ['j.kein@audi-es.de', 'f.bracco@audi-es.de'];
export const MAIL_FOR_BOOKING_REJECT = 'j.kein@audi-es.de';
export const TEL_FOR_BOOKING_REJECT = '+49(0)841 88 557 - 254';
